import { render } from "./VeterinariansPage.vue?vue&type=template&id=dcceead0&scoped=true"
import script from "./VeterinariansPage.vue?vue&type=script&lang=js"
export * from "./VeterinariansPage.vue?vue&type=script&lang=js"

import "./VeterinariansPage.vue?vue&type=style&index=0&id=dcceead0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcceead0"]])

export default __exports__